export const environment = {
  // production: true,
  // shouldEnforceLogin: true,
};
